import React from 'react';
import { DebounceInput } from 'react-debounce-input';

type Props = {
    className?: string;
    setMySearch: any;
    placeholder: string;
    setPagination?: any;
    style?: any;
    disabled?: boolean;
};

export function SearchInputV3({
    className,
    setMySearch,
    placeholder,
    style,
    disabled,
    setPagination
}: Props) {

    function handleChange(evt: any) {
        const inputValue = evt.target.value.toLowerCase();

        if (inputValue !== "") {
            setMySearch(inputValue);
            if(setPagination !== undefined){
                setPagination((prev) => ({
                    ...prev,
                    page: 1
                })); 
            }
        } else {
            setMySearch("");
            setMySearch(inputValue);
            if(setPagination !== undefined){
                setPagination((prev) => ({
                    ...prev,
                    page: 1
                })); 
            }
        }
    }

    return (
        <div className={`input-group`} style={style}>
            <span className={`input-group-text bg-hover-primary text-hover-light`}>
                <i className="bi bi-search fs-4"></i>
            </span>
            <DebounceInput
                className={`${className}`}
                placeholder={placeholder}
                disabled={disabled || false}
                minLength={2}
                onChange={handleChange}
                debounceTimeout={300}
                element="input"
                type="text"
            />
        </div>
    );
}